module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Medium Italic TH.5139a805.woff2";